import { Box, Stack, styled, Typography } from '@mui/material';
import { translateKey } from 'src/locales/translate';
import Image from 'src/components/image/Image';
import Markdown from 'src/components/markdown/Markdown';
import { GetVisitByIdStatusEnum } from 'woofwoof-api';

type VisitModalNotesTabsProps = {
  visit?: any;
};

// Notes are the clinical record, not supporting detail, so they keep the
// default body colour; only the size is normalised here.
export const StyledMarkdown = styled(Markdown)(({ theme }) => ({
  '& *': {
    fontSize: `${theme.typography.body1.fontSize} !important`,
  },
}));

export default function VisitModalNotesTabs({
  visit,
}: VisitModalNotesTabsProps) {
  const isVisitCompleted = visit.status === GetVisitByIdStatusEnum.Completed;

  return isVisitCompleted ? (
    <Stack sx={{ gap: 1, flex: 1 }}>
      {visit.notes ? (
        <>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexDirection: 'row',
            }}
          >
            <Typography>{translateKey("visit.visitNotesTab")}</Typography>
          </Box>
          <StyledMarkdown>{visit.notes}</StyledMarkdown>
        </>
      ) : (
        <Stack
          justifyContent="center"
          alignItems="center"
          gap={1}
          height="100%"
          minHeight="200px"
        >
          <Image
            disabledEffect
            visibleByDefault
            alt="auth"
            src={'/assets/illustrations/laptop-paw-blue.svg'}
            sx={{ maxWidth: 180, paddingBottom: 2 }}
          />
          <Typography>Brak notatek z wizyty</Typography>
        </Stack>
      )}
    </Stack>
  ) : null;
}
